import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class BranchCategoryMetaModel extends FormMetaModel {
    constructor() {
        super('Add Branch Category', ROUTE_PATH.branchCategory, ROUTE_PATH.branchCategoryAdd, 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const branchCatName = new SmMetaInputModel(
            'branchCatName',
            'branchCatName',
            'input',
            true,
            'col-12 col-md-6',
            1,
            1,
            'Branch Category Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            50,
            1
        );



        const buttons = {
            submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
            isFormControl: false
        };


        return {
            formInfo,
            buttons,
            branchCatName
        }
    }
}